import MoveManger from "../../../../gd/manager/move-manager"
import Task from "../../../../model2/task/task"

type ModalMoveTo_commitParams = {
    taskToMove  : Task
    targetTask  : Task
}

export default function ModalMoveTo_commitTaskMoveToTask(params: ModalMoveTo_commitParams, onMoveCallback?: {(selectedProjectId?: ID): void} ) {
    MoveManger.moveTaskToTask(params.taskToMove.id, params.targetTask.id, () => {
        onMoveCallback?.()
        gd.modal.hide()
    })
}